import { Injectable } from '@angular/core';

@Injectable()
export class Global {

     userToken: string = null;
     User: any = [];
     CanWrite = false;
     IsLoaderOn = true;
     auditTrailId: string;
     auditTrailClass: string;
     RecoveryID:string;
     WaiveOffStatusID = false;
     RolesList: any;
     IsAdmin = false;
     IsLocationSPOC = false;
     IsFinance = false;
     IsOfficeHead = false;
     IsQBROwner = false;
     IsUser = false;
     loading = false;
     CurrentRole: string;
     IsBulkLoad=false;
     EmailPattern =
          '^[a-zA-Z]{1}[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9]{3}|[a-zA-Z]{1}[a-zA-Z0-9_.+-]+@[a-zA-Z0-9.-]+.[a-zA-Z0-9]{2}$';
     IsAuditVisible = false;
     CurrentYear: Number = new Date().getFullYear();
     pageIndex = 1;
     length = 0;
     totalPage = 0;
     RecordSize = 10;
     IsConsent: boolean;
     SecondaryHeadBtnVisible = false;
     //excelPath = 'https://ingurrmpapptst1.mea.ey.net:20169/INPMC.WebAPI/Content/UploadAsset.xlsx';
     // excelPath='assets/FileSample/EmployeeRecovery.xlsx';
          excelPath='https://eyindia.sharepoint.com/sites/WebappsDocs/_layouts/download.aspx?SourceUrl=/sites/WebappsDocs/Shared%20Documents/Firmwide/IT/EmployeeRecovery.xlsx&xsdata=MDV8MDJ8fDNiYzNkODkzMTJhNTQ2ODA0MWY0MDhkZWYzYjJlODdlfDViOTczZjk5NzdkZjRiZWJiMjdkYWEwYzcwYjg0ODJjfDB8MHw2MzkyMTYxNDY4NjM1MTE2OTh8VW5rbm93bnxWR1ZoYlhOVFpXTjFjbWwwZVZObGNuWnBZMlY4ZXlKRFFTSTZJbFJsWVcxelgwRlVVRk5sY25acFkyVmZVMUJQVEU5R0lpd2lWaUk2SWpBdU1DNHdNREF3SWl3aVVDSTZJbGRwYmpNeUlpd2lRVTRpT2lKUGRHaGxjaUlzSWxkVUlqb3hNWDA9fDF8TDJOb1lYUnpMekU1T21FeVl6Z3paR0ptTFRBNU1qWXRORGxpT1MwNU16aGhMVGhqTVRZMFlUZzJOalkyWkY5bFptUXhZV1F6TXkxbFpEWTFMVFJqTURZdFlqRTJNaTFoTWpFNVlqZGhNMlkxTkdKQWRXNXhMbWRpYkM1emNHRmpaWE12YldWemMyRm5aWE12TVRjNE5qQXhOemc0TXpZME1RPT18NmEzYjE3NmFhYmNhNDc0Zjk0MWQwOGRlZjNiMmU4N2R8ZDRkZDM2N2Q3ZDc0NGQ2Zjg3MWU4NmJlYzVlMzJhYTc%3D&sdata=ZStuRzZjNzBIL0xnbVh3TXVsb0ROUGJtRERiZjBHNkdTNmJOU24vL1l2OD0%3D&ovuser=5b973f99-77df-4beb-b27d-aa0c70b8482c%2CRavi.Khambayat%40in.ey.com';

     privacyPath = 'https://ingurrmpapptst1.mea.ey.net:20169/INPMC.WebAPI/Content/PrivacyNotice.docx';
     ShowAlert(msg: string) {
          alert(msg);
     }
}
